import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ApiClientService } from './api-client.service';

@NgModule({
  imports: [
    HttpClientModule,
  ],
  providers: [ApiClientService],
})
export class ApiClientModule { }
